<template>
  <div class="introduction">
    <h3><span>公司概况</span>／Company Profile</h3>

    <div class="flImg">
      <img src="@/assets/images/new-img/company/company_img.png" />
    </div>
    <div class="frInfo">
      <h3 style="text-align: left; margin-bottom: 0">
        国内餐饮供应链杰出服务商
      </h3>
      <p style="padding-top: 15px; line-height: 25px; text-align: justify">
        2014年6月6日，美菜正式成立。美菜一直致力于用互联网思维去改变国内现代农业和餐饮供应链，以独有的“两端一链一平台”模式，创新升级农产品供应链，提高流通效率，让利两端。专注为全国近千万家餐厅，提供全品类、全程无忧的一站式餐饮食材采购服务。2018年9月，估值近70亿美元。5年来，美菜保持快速增长势头。
      </p>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  name: "business",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.introduction {
  width: 1000px;
  margin: 80px auto;
  .clear {
    clear: both;
  }
  h3 {
    text-align: center;
    margin-bottom: 50px;
    font-size: 18px;
    span {
      font-size: 30px;
    }
  }
  .flImg {
    float: left;
    width: 43%;
  }
  .frInfo {
    float: left;
    width: 57%;
    p {
      color: #757575;
      line-height: 25px;
      margin-top: 10px;
    }
  }
}
</style>